export function usePassUiState() {
  return async (legacyApp: any, taskPanelOpen: boolean) => {
    legacyApp.$store.dispatch('setTaskPanelOpen', taskPanelOpen)
  }
}
